import React, { createContext, useContext, useState, useCallback, useRef, useEffect } from "react";
import { isEqual } from "lodash";

// Context 用于在多个可视化组件之间共享 counter 值
const CrossCounterContext = createContext({
  crossCounterData: {},
  reportCrossCounterData: () => {},
  refreshing: false,
});

export function CrossCounterProvider ({ children, refreshing = false }) {
  const [crossCounterData, setCrossCounterData] = useState({});
  const prevRefreshingRef = useRef(false);
  const [reportVersion, setReportVersion] = useState(0);

  // 检测 refreshing 上升沿（开始刷新）：清空 crossCounterData
  // 检测 refreshing 下降沿（刷新完成）：递增 reportVersion 触发所有 counter 重新上报
  useEffect(() => {
    if (refreshing && !prevRefreshingRef.current) {
      // 刷新开始：清空旧数据
      setCrossCounterData({});
    } else if (!refreshing && prevRefreshingRef.current) {
      // 刷新完成：所有查询已返回，触发未受影响的 counter 重新上报当前值
      setReportVersion(v => v + 1);
    }
    prevRefreshingRef.current = refreshing;
  }, [refreshing]);

  // reportVersion 变化时生成新的函数引用，
  // 作为 counter useEffect 的依赖项，强制所有 counter 重新上报
  const reportCrossCounterData = useCallback((id, value) => {
    setCrossCounterData(prev => {
      if (prev && isEqual(prev[id], value)) {
        return prev;
      }
      return {
        ...(prev || {}),
        [id]: value,
      };
    });
  }, [reportVersion]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <CrossCounterContext.Provider value={{ crossCounterData, reportCrossCounterData, refreshing }}>
      {children}
    </CrossCounterContext.Provider>
  );
}

export function useCrossCounter() {
  return useContext(CrossCounterContext);
}
